import {LocalDate} from "@js-joda/core";
import {Drawer, Stack, TextField} from "@mui/material";
import React from "react";
import {
	  addExpense,
	  cat,
	  cos,
	  Expense,
	  generateMainFirebaseRtdbKey,
	  getDateTextFromMillis,
	  getExpenseCategorySerialNumberFromText,
	  getExpenseCategoryTextArray,
	  getExpenseCatTextFromSN,
	  getMillisFromDateText,
	  getValidPositiveNumber,
	  isValidPositiveNumber
} from "../../../firebase/index.js";
import APXActionButtons from "../../../reusables/APXActionButtons.jsx";
import {APXAutoComplete} from "../../../reusables/APXAutoComplete.jsx";
import type {BSLProps} from "../../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../../reusables/js/APXBottomSheetLayoutUtils.js";
import {hideNumberSpinner} from "../../../reusables/js/APXCrucialStyles.js";


export default function AddNewExpenseBSL({exp, industryKey, uid, onClose}: { industryKey: string, exp: Expense } & BSLProps) {
	  
	  const expForEdit: Expense = exp;
	  
	  React.useEffect(() => {
			 if (expForEdit) {
					setDetails(expForEdit.expenseDetails);
					setCategoryText(getExpenseCatTextFromSN(expForEdit.expenseSerialNumber));
					setCost(expForEdit.expenseCost);
					setDateText(getDateTextFromMillis(expForEdit.expenseMillis));
			 }
	  }, [expForEdit]);
	  
	  const {isOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const [disablePositiveByDefault, setDisablePositiveByDefault] = React.useState(true);
	  
	  const [details, setDetails] = React.useState("");
	  const [dateText, setDateText] = React.useState("");
	  const [categoryText, setCategoryText] = React.useState(getExpenseCategoryTextArray()[0]);
	  const [cost, setCost] = React.useState(0);
	  
	  React.useEffect(() => {
			 setDisablePositiveByDefault(/*FALSY->*/ !!!details.trim() || /*FALSY->*/ !!!dateText.trim() || /*FALSY->*/ !!!categoryText.trim() || /*NOT->*/ !isValidPositiveNumber(cost));
	  }, [cost, details, dateText, categoryText]);
	  
	  React.useEffect(() => {
			 details.length >= 150 && setDetails(prevState => prevState.slice(0, -1));
	  }, [details]);
	  
	  const handleCancel = () => {
			 setDetails("");
			 setDateText("");
			 setCategoryText("");
			 setCost(0);
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 const key = expForEdit ? expForEdit.expenseKey : generateMainFirebaseRtdbKey();
			 const millis = getMillisFromDateText(dateText);
			 const expense = new Expense(key, millis, details.trim(), getExpenseCategorySerialNumberFromText(categoryText.trim()), cost);
			 addExpense(uid, industryKey, key, expense);
			 handleCancel();
	  };
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <TextField label={"Details (max. 150 chars)"} variant="outlined" fullWidth required
											 value={details}
											 onChange={(e) => setDetails(e.target.value)}
							  />
							  <Stack direction={{xs: "column", sm: "row"}} spacing={2}>
									 <TextField label={"Date"} variant="outlined" fullWidth required
													type="date"
													InputLabelProps={{shrink: true}}
													InputProps={{inputProps: {max: LocalDate.now().toString()}}}
													value={dateText}
													onChange={(e) => setDateText(e.target.value)}
									 />
									 <APXAutoComplete textFieldLabel={cat} required fullWidth
															options={getExpenseCategoryTextArray()}
															value={categoryText}
															onOptionSelected={setCategoryText}
									 />
									 <TextField label={cos} variant="outlined" fullWidth required type="number" InputProps={hideNumberSpinner}
													value={cost}
													onChange={(e) => setCost(getValidPositiveNumber(e.target.value))}
									 />
							  </Stack>
							  
							  <APXActionButtons onCancel={handleCancel}
													  onAdd={handleAdd}
													  disablePositiveByDefault={disablePositiveByDefault}
							  />
						</Stack>
				 </Drawer>
	  );
}
